import _ from 'lodash';
import {
  useEffect,
  useRef
} from 'react';



export function useInfiniteScroll({
  onBecameVisible
}: {
  onBecameVisible: () => void;
}) {
  const observerTargetRef = useRef(null);

  useEffect(() => {

    const target = observerTargetRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const last = _.last(entries);
        if (last?.isIntersecting) {
          onBecameVisible();
        }
      },
      {
        threshold: 1
      }
    );

    if (target) {
      observer.observe(target);
    }
    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [
    observerTargetRef,
    onBecameVisible
  ]);

  return observerTargetRef;
}
